export const messages = {
  en: {
    messages: {
      email: 'This doesn’t seem to be a valid email',
      required: '11',
    },
    custom: {
      emailField: {
        required: 'Your email is empty',
      },
    },
  },
};
